import React, { Component } from 'react';
import {Bar} from 'react-chartjs-2';

import '../estaHome.css';
import './intents.css';

import functions from '../../../../functions/Estadisticas/getData';

class Conversa extends Component{

    constructor(){
        super();
        this.state = {
            interacciones: '',
            data:{
                labels: [],
                datasets: [{
                    label: "",
                    borderColor: '',
                    data: [],
                    backgroundColor: [
                    ],
                }]
            }
        };

        functions.GetDataGraficoInteraccionesCreditos().then((datos) => {
            this.setState({
                data:{
                    labels: datos.labels,
                    datasets: [{
                        label: "Créditos",
                        borderColor: 'rgb(63, 80, 121)',
                        data: datos.values,
                        backgroundColor: [
                            'rgba(238,60,22,0.6)',
                            'rgba(22,238,238,0.6)',
                            'rgba(153,238,22,0.6)',
                            'rgba(100,156,22,0.6)',
                            'rgba(30,156,22,0.6)',
                            'rgba(201,156,22,0.6)',
                            'rgba(108,63,191,0.6)',
                            'rgba(63,182,191,0.6)',
                            'rgba(120,156,22,0.6)',
                            'rgba(153,238,22,0.6)',
                            'rgba(89,60,22,0.6)',
                            'rgba(187,156,22,0.6)',
                            'rgba(199,156,22,0.6)', 
                            'rgba(22,238,238,0.6)',
                            'rgba(238,156,22,0.6)',
                        ],
                    }]
                }
            });
        });
    }

    render(){
        
        return(
            <div className='col s12 x12'>
                <div className='card-panel empresaCard interacciones'>
                    <p>Intenciones por Créditos</p>
                    {/* mando a llamar el componente y le paso la data */}
                    <Bar heigth="5em" data={this.state.data}/> 
                </div>
            </div>
        );
    }
}

export default Conversa;